var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    fillRule: "evenodd",
    d: "M6.088 23h1.015c.56 0 1.014-.445 1.014-1V9c0-.285.093-7 8.118-7 7.977 0 8.116 6.72 8.118 7v13c0 .555.455 1 1.015 1h1.014c3.357 0 6.089-2.69 6.089-6s-2.732-6-6.089-6V9c0-.09-.115-9-10.147-9C6.204 0 6.088 8.91 6.088 9v2C2.731 11 0 13.69 0 17s2.731 6 6.088 6zm24.353-6c0 2.205-1.82 4-4.059 4v-8c2.239 0 4.06 1.795 4.06 4zM6.088 13v8C3.85 21 2.03 19.205 2.03 17s1.821-4 4.06-4z"
  })));
}
export default SvgHeadset;